import React, { useState, useEffect } from 'react'
import { fullName as userFullName } from 'src/services/user_helpers'
import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import Button from 'src/components/common/Button'
import SvgIcon from 'src/components/common/SvgIcon'
import cn from 'classnames'
import CreditsIcon from 'src/assets/icons/purchase-credits-ico.svg'
import LogoutIcon from 'assets/icons/ico-logout.svg'
import MembershipInfo from '../membership-info/MembershipInfo'
import { useSelector, useDispatch } from 'react-redux'
import {
  setCheckoutModalOpen,
  setDefaultWorkflowNode,
  PurchaseWorkflowNode
} from 'src/actions/stripeCheckout'
import { getPlanTypeBySlug, PlanType } from 'src/services/stripe_checkout_configs'
import { fetchUserGQ } from 'src/actions/user'
import { logout } from 'src/actions/login'
import { Skeleton } from 'antd'
import PopConfirm from 'components/common/PopConfirm/PopConfirm'
import { userSelector, userLoadingSelector } from 'src/selectors'

import styles from '../panel.scss'

const PlanThemMapping = {
  [PlanType.Free]: 'free',
  [PlanType.Essentials]: 'essential',
  [PlanType.Premium]: 'premium',
  [PlanType.InvitationMaker]: 'invitation-maker',
  [PlanType.partyHost]: 'party-host'
}

const ProfilePanel = () => {
  const [logoutConfirmVisible, setLogoutConfirmVisible] = useState(false)
  const user = useSelector(userSelector) || {}
  const userLoading = useSelector(userLoadingSelector)
  const currentSub = user.current_subscription
  const dispatch = useDispatch()

  const handleLogOut = () => {
    setLogoutConfirmVisible(false)
    dispatch(logout())
  }

  useEffect(() => {
    dispatch(fetchUserGQ())
  }, [])

  let theme = 'free'
  let canShowPurchaseCreditsButton = false
  let canShowPurchasePlan = false
  let isFreTrailUsed = true

  if (currentSub) {
    const planType = getPlanTypeBySlug(currentSub.plan.slug)
    theme = PlanThemMapping[planType]
    canShowPurchaseCreditsButton = planType !== PlanType.Free
    canShowPurchasePlan = !canShowPurchaseCreditsButton
    isFreTrailUsed = !user.is_trial_available
  }

  const userName = userFullName(user)

  if (userLoading) {
    return (
      <div className={styles['skeleton-container']}>
        <Skeleton active avatar paragraph={{ rows: 6 }} title />
      </div>
    )
  }

  return (
    <>
      <section className={cn(styles['profile-menu-panel'], styles[theme])}>
        <div className={styles['logout-wrapper']} onClick={() => setLogoutConfirmVisible(true)}>
          <SvgIcon icon={LogoutIcon} width={26} height={26} />
        </div>
        <div className={styles['menu-avatar-name']}>
          <UserAvatarContainer user={user} size={100} />
          <h2 className={styles['avatar-h2']}>{userName}</h2>
        </div>
        <div className={styles['membership-info']}>
          <MembershipInfo />
        </div>
        {canShowPurchaseCreditsButton && (
          <Button
            purple={theme === PlanThemMapping[PlanType.Premium]}
            className={cn(styles['purchase-button'], styles[theme])}
            onClick={() => {
              dispatch(setDefaultWorkflowNode(PurchaseWorkflowNode.PurchaseCredits))
              dispatch(setCheckoutModalOpen(true))
            }}
          >
            <SvgIcon icon={CreditsIcon} width={18} height={18} />
            Purchase Credits
          </Button>
        )}
        {canShowPurchasePlan && (
          <Button
            className={styles['purchase-button']}
            onClick={() => {
              dispatch(setDefaultWorkflowNode(PurchaseWorkflowNode.PurchasePlan))
              dispatch(setCheckoutModalOpen(true))
            }}
          >
            {isFreTrailUsed ? <>Subscribe</> : <>REDEEM YOUR FREE WEEK</>}
          </Button>
        )}
      </section>
      <PopConfirm
        visible={logoutConfirmVisible}
        onClose={() => setLogoutConfirmVisible(false)}
        cancelText="No"
        confirmText="Yes"
        type="cancel"
        cancelType="normal"
        onConfirm={handleLogOut}
      >
        Are you sure you want to log out?
      </PopConfirm>
    </>
  )
}

export default ProfilePanel
